import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LoaderService } from '@services/loader.service';
import { PartnerClientSetUpService } from '@services/partner-clientsetup.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wsb-partner-clientsetup-link',
  templateUrl: './partner-clientsetup-link.component.html',
  styleUrls: ['./partner-clientsetup-link.component.scss'],
  standalone: false
})
export class PartnerLinkComponent implements OnInit {
  partnerUrlForm: UntypedFormGroup = null;

  constructor(
    private clientSetUpService: PartnerClientSetUpService,
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.partnerUrlForm = this.formBuilder.group({
      partnerUrl: ['']
    });
    this.loaderService.show();

    this.clientSetUpService
      .getPartnerUrl()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(url => {
        const link = url['partner-url'];
        this.getForm().partnerUrl.setValue(link);
      });
  }

  private getForm() {
    return this.partnerUrlForm.controls;
  }
}
